import { InfoCircleTwoTone } from "@ant-design/icons";
import { Popover, Space } from "antd";
import {
    CardPhotoTypeNames,
    CardTitlePhotos
} from "models/cardIngestion";
import moment from "moment-timezone";
import { FC } from "react";

const PackageRecDate = ({date}:{date:string|null}) => {
    if(!date) {
        return null;
    }

    return <>{moment(date).local().format('MM/DD/YY')}</>;
}

const PhotoTaker: FC<{ 
    pkgRecDate: string|null; 
    photos: CardTitlePhotos[] 
}> = ({ pkgRecDate, photos }) => {
    if (photos.length === 0 && !pkgRecDate) {
        return <></>;
    }
    
    const name = photos[0].takenByName;
    if (photos.every(p => p.takenByName === name)) {
        return <Space>
            <PackageRecDate date={pkgRecDate} />
            {`${name.match(/\b(\w)/g)!.join('.')}.`}
        </Space>
    }

    const content = <Space direction="vertical" size="middle">
        {photos.map((p, idx) => <div key={idx}>
            {CardPhotoTypeNames[p.type]}: {p.takenByName}</div>
        )}
    </Space>;

    return <Space>
        <PackageRecDate date={pkgRecDate} />
        <span>{`${photos.length} Users`}</span>
        <Popover content={content} >
            <InfoCircleTwoTone style={{ cursor: 'pointer' }} />
        </Popover>
    </Space>
};

export default PhotoTaker;